import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import type { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import { FullscreenExerciseDetails } from "@/modules/sessions/sessionDetails/components/fullscreenExerciseDetails"
import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import { HustleupIcon } from "@images/hustleupIcon"
import { CardioSelectedIcon } from "@images/svgIcons/cardioIcon"
import { GymSelectedIcon } from "@images/svgIcons/gymIcon"
import { WeightliftingSelectedIcon } from "@images/svgIcons/weightliftingIcon"
import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"
import { useProgram } from "@modules/programs/hooks/usePrograms"

type SessionDetailsContentFullscreenProps = {
  session: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function SessionDetailsContentFullscreen({
  session,
  programId,
  className,
  ...props
}: SessionDetailsContentFullscreenProps) {
  const { data: program } = useProgram(programId)

  return (
    <div className={cn("flex h-screen flex-col overflow-hidden", className)} {...props}>
      <div className="flex flex-1 flex-col overflow-auto p-6" style={{ height: "calc(100vh - 30px)" }}>
        <div className="flex">
          <div className="flex-1 content-center pl-5">
            <Text fontStyle="HL">{session.name}</Text>
            <div className="mt-2 flex flex-row items-center justify-start gap-4">
              {session.gymnasticTag && <GymSelectedIcon color="" width={40} height={40} />}
              {session.weightliftingTag && <WeightliftingSelectedIcon color="" width={40} height={40} />}
              {session.cardioTag && <CardioSelectedIcon color="" width={40} height={40} />}

              {program.owner && (
                <div className="ml-3 flex flex-row items-center gap-1">
                  <ProfileAvatar
                    profile={{ avatar: program.owner.avatar, username: program.owner.username }}
                    className="size-12"
                  />
                  <Text fontStyle="LL" className="event-content ml-2 text-textDefault-body">
                    {program.owner.username}
                  </Text>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-1 gap-5 pt-6">
          {session.blocks
            .filter((block) => block.type === SessionBlockType.SESSION_EXERCISE)
            .map((block, key) => (
              <FullscreenExerciseDetails key={key} exercise={block.content} />
            ))}
        </div>
      </div>
      <div className="mb-1 flex" style={{ height: 30 }}>
        <HustleupIcon className="m-auto w-40 text-textDefault-heading" color="currentColor" />
      </div>

      {/*{showLeaderbord &&
              <div className="flex">
                <div style={{
                  backgroundColor: theme.primaryColor,
                  padding: 2,
                  borderRadius: 40,
                  marginTop: 50,
                  marginBottom: 50,
                  marginLeft: 20,
                  marginRight: 20,
                }}></div>
                <div><p>leaderbord</p></div>
              </div>
            }*/}
    </div>
  )
}
